<template lang="pug">
	section
		p.mb-5
			| Knowing this helps us better customize your experience
		section.radio-wrap
			.radio
				sfc-radio(v-model="hasAccount" :radio-value="`yes`" label="Yes" @click="next('yes')" name="yes")
		section.radio-wrap
			.radio
				sfc-radio(v-model="hasAccount" :radio-value="`no`" label="No" @click="next('no')" name="no")
		section.radio-wrap
			.radio
				sfc-radio(v-model="hasAccount" :radio-value="`other`" label="I’m not sure" @click="next('other')" name="other")

</template>

<script>
import SfcRadio from '@/common/components/inputs/v2/radio'

export default {

	components:{
		SfcRadio
	},

	props: {
	},

	data() {
		return {
			errors: {
			},
			hasAccount: undefined,
			progressLength: 0
		}
	},

	methods: {
		next(value){

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "hasAccount", value: value})

			if(value == "yes"){
				this.$emit(
					'next',
					90,
					"Log In to your account",
					"sfc-log-in-to-your-account",
					{
						progressLength: this.progressLength,
						title: "Do you have a Savingforcollege.com account?",
						component: "sfc-do-you-have-an-account"
					}
				)
			}else{
				this.$emit('next', 0, "What is your state of residence?", "sfc-what-is-your-state-of-residence")
			}

		},
	}

}
</script>
